/*
 * provide a way to submit forms cross-domain
 */

(function () {
    function createDummyIframe(iframeName) {
        $('#' + iframeName).remove();
        const dummyIframe = document.createElement('iframe');
        dummyIframe.setAttribute('id', iframeName);
        dummyIframe.setAttribute('name', iframeName);
        dummyIframe.setAttribute('width', '0');
        dummyIframe.setAttribute('height', '0');
        dummyIframe.setAttribute('frameBorder', '0');
        dummyIframe.style.position = 'absolute';
        dummyIframe.style.top = '-1000px';
        document.body.appendChild(dummyIframe);
        return dummyIframe;
    }

    window.submitFormToIframe = function (formEl, iframeName) {
        createDummyIframe(iframeName);
        formEl.setAttribute('target', iframeName);

        // Submit-handlers don't fire when `.submit()` is called imperatively, so we have to replicate the behavior of
        // csrfTokens.js's global-submit-handler here.
        const token = window.getCsrfTokenOrNull();
        if (token != null) {
            const tokenInput = '<input type="hidden" name="_csrf" value="' + token + '" />';
            $(formEl).not(':has(input[name=_csrf])').append(tokenInput);
        }

        formEl.submit();
    };

    window.getURLInHiddenIframe = function (url, iframeName) {
        const dummyIframe = createDummyIframe(iframeName);
        dummyIframe.setAttribute('src', url);
    };
})();
